import { VChip } from 'vuetify/lib/components/VChip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VChip,{class:_vm.colorClass},[(_vm.mapText===_vm.mapGreen)?_c('span',[_vm._v(" "+_vm._s(_vm.mapText)+" ")]):(_vm.mapText===_vm.mapOrange)?_c('span',[_vm._v(" "+_vm._s(_vm.mapText)+" ")]):(_vm.mapText===_vm.mapRed)?_c('span',[_vm._v(" "+_vm._s(_vm.mapText)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }